/**
 * Vue3ファイル 読込等設定
 */

/* VueInstance定義 */
import { createApp } from "vue";

/* Vue ファイル定義 */
// スケジュール一覧
import ScheduleIndex from "./pages/schedule/index.vue";
const app = createApp({})
app.component('schedule-index', ScheduleIndex);
app.mount('#app');
